import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { Link } from 'react-router-dom';
import { HeadphonesIcon, MessageCircleIcon, FileTextIcon, CheckCircleIcon, ClockIcon, AwardIcon, ShieldIcon, UserIcon, BarChartIcon, BookOpenIcon, UsersIcon, StarIcon, PhoneIcon, MailIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AssistancePremiumPage() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-1261">
      <Navbar data-id="element-1262" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden" data-id="element-1263">
        <div className="container mx-auto px-4 relative z-10" data-id="element-1264">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1265">
            <div className="lg:w-1/2" data-id="element-1266">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} data-id="element-1267">
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1268">
                  Fonctionnalité
                </span>
                <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6" data-id="element-1269">
                  Assistance Premium personnalisée
                </h1>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-1270">
                  Bénéficiez d'un accompagnement expert pour maximiser vos
                  chances de succès dans les appels d'offres. Notre équipe de
                  spécialistes est à votre disposition pour vous guider à chaque
                  étape.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-1271">
                  <Link to="/premium-offers" data-id="element-1272">
                    <Button variant="primary" size="lg" className="shadow-lg shadow-blue-500/20" data-id="element-1273">
                      Découvrir nos offres
                    </Button>
                  </Link>
                  <Link to="/parler-conseiller" data-id="element-1274">
                    <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-1275">
                      Parler à un conseiller
                    </Button>
                  </Link>
                </div>
              </motion.div>
            </div>
            <div className="lg:w-1/2" data-id="element-1276">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="relative" data-id="element-1277">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-yellow-500 rounded-2xl blur opacity-20" data-id="element-1278"></div>
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 relative" data-id="element-1279">
                  <div className="flex items-center mb-6" data-id="element-1280">
                    <div className="h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-4" data-id="element-1281">
                      <HeadphonesIcon size={24} data-id="element-1282" />
                    </div>
                    <div data-id="element-1283">
                      <h3 className="font-semibold text-gray-900" data-id="element-1284">
                        Centre d'assistance Premium
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-1285">
                        Support prioritaire dédié
                      </p>
                    </div>
                  </div>
                  <div className="space-y-4 mb-6" data-id="element-1286">
                    <div className="bg-gray-50 p-4 rounded-lg flex items-start" data-id="element-1287">
                      <div className="h-10 w-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 mr-3 flex-shrink-0" data-id="element-1288">
                        <MessageCircleIcon size={20} data-id="element-1289" />
                      </div>
                      <div data-id="element-1290">
                        <div className="flex justify-between items-start" data-id="element-1291">
                          <h4 className="font-medium text-gray-900" data-id="element-1292">
                            Assistance immédiate
                          </h4>
                          <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full" data-id="element-1293">
                            En ligne
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mt-1" data-id="element-1294">
                          Un expert est disponible pour répondre à vos questions
                          en temps réel.
                        </p>
                        <Button variant="primary" size="sm" className="mt-2" data-id="element-1295">
                          Démarrer une conversation
                        </Button>
                      </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg flex items-start" data-id="element-1296">
                      <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3 flex-shrink-0" data-id="element-1297">
                        <FileTextIcon size={20} data-id="element-1298" />
                      </div>
                      <div data-id="element-1299">
                        <h4 className="font-medium text-gray-900" data-id="element-1300">
                          Revue de dossier
                        </h4>
                        <p className="text-sm text-gray-600 mt-1" data-id="element-1301">
                          Faites vérifier votre dossier de candidature par nos
                          experts avant soumission.
                        </p>
                        <div className="flex items-center text-sm mt-2 text-blue-600" data-id="element-1302">
                          <span data-id="element-1303">Planifier une revue</span>
                          <ChevronRightIcon size={16} className="ml-1" data-id="element-1304" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-1305">
                    <div className="flex items-center text-gray-500" data-id="element-1306">
                      <ClockIcon size={14} className="mr-1" data-id="element-1307" />
                      <span data-id="element-1308">Temps de réponse moyen: 2 minutes</span>
                    </div>
                    <a href="#" className="text-blue-600 font-medium" data-id="element-1309">
                      Tous les services
                    </a>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-yellow-100 to-transparent opacity-70" data-id="element-1310"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-radial from-blue-50 to-transparent opacity-70" data-id="element-1311"></div>
      </section>
      {/* Features Section */}
      <section className="py-20" data-id="element-1312">
        <div className="container mx-auto px-4" data-id="element-1313">
          <div className="text-center mb-16" data-id="element-1314">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1315">
              Services inclus
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1316">
              Un accompagnement complet à chaque étape
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1317">
              Notre service d'assistance Premium vous offre un soutien
              personnalisé pour optimiser vos chances de succès dans les appels
              d'offres.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1318">
            {[{
            icon: <FileTextIcon size={32} data-id="element-1319" />,
            title: 'Revue de dossier',
            description: "Nos experts vérifient l'exhaustivité et la conformité de vos dossiers de candidature avant soumission."
          }, {
            icon: <MessageCircleIcon size={32} data-id="element-1320" />,
            title: 'Assistance en temps réel',
            description: "Bénéficiez d'un support immédiat par chat, email ou téléphone pour toutes vos questions urgentes."
          }, {
            icon: <BookOpenIcon size={32} data-id="element-1321" />,
            title: 'Conseils stratégiques',
            description: 'Recevez des recommandations personnalisées pour améliorer vos offres et augmenter vos chances de succès.'
          }].map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1322">
                <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1323">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1324">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-1325">{feature.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Expert Team */}
      <section className="py-20 bg-gray-50" data-id="element-1326">
        <div className="container mx-auto px-4" data-id="element-1327">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1328">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1329">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1330">
                Notre équipe
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-1331">
                Des experts à votre service
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-1332">
                Notre équipe d'experts pluridisciplinaires vous accompagne pour
                maximiser vos chances de succès dans les appels d'offres.
              </p>
              <div className="space-y-5" data-id="element-1333">
                {[{
                icon: <UserIcon size={24} data-id="element-1334" />,
                title: 'Consultants spécialisés par secteur',
                description: 'Nos consultants possèdent une expertise approfondie dans leur domaine et connaissent parfaitement les exigences spécifiques de chaque secteur.'
              }, {
                icon: <AwardIcon size={24} data-id="element-1335" />,
                title: 'Juristes spécialisés en marchés publics',
                description: 'Nos juristes vous aident à naviguer dans les complexités réglementaires et à vous assurer de la conformité de vos dossiers.'
              }, {
                icon: <BarChartIcon size={24} data-id="element-1336" />,
                title: 'Analystes financiers',
                description: "Nos analystes vous aident à optimiser votre proposition financière pour qu'elle soit compétitive tout en restant rentable."
              }].map((expert, index) => <div key={index} className="flex items-start" data-id="element-1337">
                    <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1338">
                      {expert.icon}
                    </div>
                    <div data-id="element-1339">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-1340">
                        {expert.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-1341">{expert.description}</p>
                    </div>
                  </div>)}
              </div>
            </motion.div>
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1342">
              <div className="grid grid-cols-2 gap-4" data-id="element-1343">
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-1344">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Expert" className="w-20 h-20 rounded-full mx-auto mb-4" data-id="element-1345" />
                  <h3 className="text-center font-bold text-gray-900" data-id="element-1346">
                    Ahmed Benali
                  </h3>
                  <p className="text-center text-sm text-gray-600 mb-3" data-id="element-1347">
                    Expert BTP & Construction
                  </p>
                  <div className="flex justify-center" data-id="element-1348">
                    <div className="flex items-center text-yellow-500" data-id="element-1349">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-1350" />)}
                    </div>
                  </div>
                  <p className="text-center text-xs text-gray-500 mt-2" data-id="element-1351">
                    15+ ans d'expérience
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-1352">
                  <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Expert" className="w-20 h-20 rounded-full mx-auto mb-4" data-id="element-1353" />
                  <h3 className="text-center font-bold text-gray-900" data-id="element-1354">
                    Leila Mansouri
                  </h3>
                  <p className="text-center text-sm text-gray-600 mb-3" data-id="element-1355">
                    Juriste Marchés Publics
                  </p>
                  <div className="flex justify-center" data-id="element-1356">
                    <div className="flex items-center text-yellow-500" data-id="element-1357">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-1358" />)}
                    </div>
                  </div>
                  <p className="text-center text-xs text-gray-500 mt-2" data-id="element-1359">
                    12+ ans d'expérience
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-1360">
                  <img src="https://randomuser.me/api/portraits/men/75.jpg" alt="Expert" className="w-20 h-20 rounded-full mx-auto mb-4" data-id="element-1361" />
                  <h3 className="text-center font-bold text-gray-900" data-id="element-1362">
                    Karim Zouaoui
                  </h3>
                  <p className="text-center text-sm text-gray-600 mb-3" data-id="element-1363">
                    Expert IT & Télécoms
                  </p>
                  <div className="flex justify-center" data-id="element-1364">
                    <div className="flex items-center text-yellow-500" data-id="element-1365">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill={i < 4 ? 'currentColor' : 'none'} stroke="currentColor" data-id="element-1366" />)}
                    </div>
                  </div>
                  <p className="text-center text-xs text-gray-500 mt-2" data-id="element-1367">
                    10+ ans d'expérience
                  </p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-1368">
                  <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="Expert" className="w-20 h-20 rounded-full mx-auto mb-4" data-id="element-1369" />
                  <h3 className="text-center font-bold text-gray-900" data-id="element-1370">
                    Nadia Toumi
                  </h3>
                  <p className="text-center text-sm text-gray-600 mb-3" data-id="element-1371">
                    Analyste Financière
                  </p>
                  <div className="flex justify-center" data-id="element-1372">
                    <div className="flex items-center text-yellow-500" data-id="element-1373">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill={i < 5 ? 'currentColor' : 'none'} stroke="currentColor" data-id="element-1374" />)}
                    </div>
                  </div>
                  <p className="text-center text-xs text-gray-500 mt-2" data-id="element-1375">
                    8+ ans d'expérience
                  </p>
                </div>
              </div>
              <div className="mt-6 bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-1376">
                <div className="flex items-center mb-4" data-id="element-1377">
                  <UsersIcon size={24} className="text-blue-600 mr-3" data-id="element-1378" />
                  <h3 className="font-bold text-gray-900" data-id="element-1379">Équipe complète</h3>
                </div>
                <p className="text-gray-600 mb-4" data-id="element-1380">
                  Notre équipe compte plus de 20 experts couvrant tous les
                  secteurs d'activité majeurs en Afrique du Nord et de l'Ouest.
                </p>
                <Button variant="outline" fullWidth className="border-blue-900" data-id="element-1381">
                  Voir toute l'équipe
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Services Details */}
      <section className="py-20" data-id="element-1382">
        <div className="container mx-auto px-4" data-id="element-1383">
          <div className="text-center mb-16" data-id="element-1384">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1385">
              Nos services
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1386">
              Un accompagnement sur mesure
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1387">
              Découvrez en détail les services d'assistance Premium que nous
              proposons pour vous aider à réussir vos appels d'offres.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1388">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1389">
              <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1390">
                <FileTextIcon size={32} data-id="element-1391" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1392">
                Revue de dossier complète
              </h3>
              <p className="text-gray-600 mb-5" data-id="element-1393">
                Nos experts examinent en détail votre dossier de candidature
                pour s'assurer qu'il répond à toutes les exigences et maximise
                vos chances de succès.
              </p>
              <div className="space-y-3 mb-5" data-id="element-1394">
                {['Vérification de la conformité administrative', 'Analyse de la partie technique', "Optimisation de l'offre financière", "Recommandations d'amélioration", 'Rapport détaillé avec points forts/faibles'].map((item, index) => <div key={index} className="flex items-center" data-id="element-1395">
                    <CheckCircleIcon size={18} className="text-green-500 mr-2 flex-shrink-0" data-id="element-1396" />
                    <span className="text-gray-700" data-id="element-1397">{item}</span>
                  </div>)}
              </div>
              <div className="pt-4 border-t border-gray-100" data-id="element-1398">
                <Button variant="primary" fullWidth data-id="element-1399">
                  Demander une revue
                </Button>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1400">
              <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1401">
                <MessageCircleIcon size={32} data-id="element-1402" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1403">
                Assistance en temps réel
              </h3>
              <p className="text-gray-600 mb-5" data-id="element-1404">
                Bénéficiez d'un support immédiat de nos experts pour répondre à
                vos questions urgentes et résoudre vos problèmes.
              </p>
              <div className="space-y-3 mb-5" data-id="element-1405">
                {['Support par chat, email et téléphone', 'Temps de réponse garanti sous 15 minutes', 'Accès prioritaire à nos experts', 'Assistance 6j/7, de 8h à 20h', 'Suivi personnalisé de vos demandes'].map((item, index) => <div key={index} className="flex items-center" data-id="element-1406">
                    <CheckCircleIcon size={18} className="text-green-500 mr-2 flex-shrink-0" data-id="element-1407" />
                    <span className="text-gray-700" data-id="element-1408">{item}</span>
                  </div>)}
              </div>
              <div className="pt-4 border-t border-gray-100" data-id="element-1409">
                <Button variant="primary" fullWidth data-id="element-1410">
                  Contacter un expert
                </Button>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1411">
              <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1412">
                <BookOpenIcon size={32} data-id="element-1413" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1414">
                Conseils stratégiques
              </h3>
              <p className="text-gray-600 mb-5" data-id="element-1415">
                Recevez des recommandations personnalisées pour améliorer votre
                stratégie de réponse aux appels d'offres.
              </p>
              <div className="space-y-3 mb-5" data-id="element-1416">
                {['Analyse de votre positionnement', 'Identification des avantages concurrentiels', 'Recommandations sur les points à mettre en avant', 'Conseils sur la tarification', 'Stratégie de différenciation'].map((item, index) => <div key={index} className="flex items-center" data-id="element-1417">
                    <CheckCircleIcon size={18} className="text-green-500 mr-2 flex-shrink-0" data-id="element-1418" />
                    <span className="text-gray-700" data-id="element-1419">{item}</span>
                  </div>)}
              </div>
              <div className="pt-4 border-t border-gray-100" data-id="element-1420">
                <Button variant="primary" fullWidth data-id="element-1421">
                  Planifier une session
                </Button>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1422">
              <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-1423">
                <ShieldIcon size={32} data-id="element-1424" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1425">
                Assistance juridique
              </h3>
              <p className="text-gray-600 mb-5" data-id="element-1426">
                Nos juristes spécialisés vous aident à naviguer dans les
                complexités légales et réglementaires des marchés publics.
              </p>
              <div className="space-y-3 mb-5" data-id="element-1427">
                {['Vérification de la conformité légale', 'Conseils sur les clauses contractuelles', 'Assistance en cas de litige', 'Accompagnement pour les recours', 'Veille réglementaire personnalisée'].map((item, index) => <div key={index} className="flex items-center" data-id="element-1428">
                    <CheckCircleIcon size={18} className="text-green-500 mr-2 flex-shrink-0" data-id="element-1429" />
                    <span className="text-gray-700" data-id="element-1430">{item}</span>
                  </div>)}
              </div>
              <div className="pt-4 border-t border-gray-100" data-id="element-1431">
                <Button variant="primary" fullWidth data-id="element-1432">
                  Consulter un juriste
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-20 bg-gray-50" data-id="element-1433">
        <div className="container mx-auto px-4" data-id="element-1434">
          <div className="text-center mb-16" data-id="element-1435">
            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1436">
              Témoignages
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1437">
              Ce que disent nos clients
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1438">
              Découvrez comment notre assistance Premium a aidé des entreprises
              à remporter des marchés importants.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1439">
            {[{
            quote: "L'assistance Premium a été décisive dans notre succès. La revue de notre dossier par les experts d'ElevateIT nous a permis d'identifier et de corriger des faiblesses que nous n'avions pas remarquées.",
            author: 'Mohammed El Amrani',
            position: 'Directeur Général, BuildTech Maroc',
            image: 'https://randomuser.me/api/portraits/men/32.jpg'
          }, {
            quote: "Le support en temps réel est incroyable. Lors de la préparation d'une offre urgente, nous avons pu obtenir des réponses à nos questions en quelques minutes, ce qui nous a permis de respecter le délai très serré.",
            author: 'Fatima Bensouda',
            position: "Responsable Appels d'Offres, MedEquip",
            image: 'https://randomuser.me/api/portraits/women/44.jpg'
          }, {
            quote: "Les conseils stratégiques de l'équipe d'ElevateIT nous ont aidés à mieux nous positionner face à la concurrence. Nous avons remporté un marché important grâce à leur approche personnalisée.",
            author: 'Youssef Kaddouri',
            position: 'PDG, InfoSystems Tunisie',
            image: 'https://randomuser.me/api/portraits/men/75.jpg'
          }].map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-1440">
                <div className="mb-6" data-id="element-1441">
                  <svg className="h-8 w-8 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-1442">
                    <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h10zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" data-id="element-1443" />
                  </svg>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-1444">"{testimonial.quote}"</p>
                <div className="flex items-center" data-id="element-1445">
                  <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4" data-id="element-1446" />
                  <div data-id="element-1447">
                    <h4 className="font-bold text-gray-900" data-id="element-1448">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-1449">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-20" data-id="element-1450">
        <div className="container mx-auto px-4" data-id="element-1451">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1452">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1453">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1454">
                Contactez-nous
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-1455">
                Besoin d'aide? Nous sommes là pour vous
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-1456">
                Notre équipe d'experts est prête à répondre à toutes vos
                questions et à vous aider à choisir la solution qui correspond
                le mieux à vos besoins.
              </p>
              <div className="space-y-6" data-id="element-1457">
                <div className="flex items-start" data-id="element-1458">
                  <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1459">
                    <PhoneIcon size={24} data-id="element-1460" />
                  </div>
                  <div data-id="element-1461">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-1462">
                      Par téléphone
                    </h3>
                    <p className="text-gray-600 mb-2" data-id="element-1463">
                      Nos conseillers sont disponibles du lundi au samedi, de 8h
                      à 20h.
                    </p>
                    <a href="tel:+33753293419" className="text-blue-600 font-medium" data-id="element-1464">
                      +33 7 53 29 34 19
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1465">
                  <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1466">
                    <MailIcon size={24} data-id="element-1467" />
                  </div>
                  <div data-id="element-1468">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-1469">Par email</h3>
                    <p className="text-gray-600 mb-2" data-id="element-1470">
                      Envoyez-nous un email et nous vous répondrons dans les 24
                      heures.
                    </p>
                    <a href="mailto:premium@elevateit.fr" className="text-blue-600 font-medium" data-id="element-1471">
                      premium@elevateit.fr
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1472">
                  <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-1473">
                    <MessageCircleIcon size={24} data-id="element-1474" />
                  </div>
                  <div data-id="element-1475">
                    <h3 className="font-bold text-gray-900 mb-1" data-id="element-1476">
                      Chat en direct
                    </h3>
                    <p className="text-gray-600 mb-2" data-id="element-1477">
                      Discutez en temps réel avec nos experts directement depuis
                      notre plateforme.
                    </p>
                    <Button variant="outline" size="sm" className="border-blue-900" data-id="element-1478">
                      Démarrer une conversation
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-1479">
              <div className="bg-white p-8 rounded-xl shadow-xl border border-gray-100" data-id="element-1480">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1481">
                  Demander un rappel
                </h3>
                <form className="space-y-4" data-id="element-1482">
                  <div data-id="element-1483">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1484">
                      Nom complet
                    </label>
                    <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Votre nom" data-id="element-1485" />
                  </div>
                  <div data-id="element-1486">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1487">
                      Entreprise
                    </label>
                    <input type="text" id="company" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Nom de votre entreprise" data-id="element-1488" />
                  </div>
                  <div data-id="element-1489">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1490">
                      Email professionnel
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="votre@email.com" data-id="element-1491" />
                  </div>
                  <div data-id="element-1492">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1493">
                      Numéro de téléphone
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="+33 X XX XX XX XX" data-id="element-1494" />
                  </div>
                  <div data-id="element-1495">
                    <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1496">
                      Service souhaité
                    </label>
                    <select id="service" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" data-id="element-1497">
                      <option data-id="element-1498">Revue de dossier</option>
                      <option data-id="element-1499">Assistance en temps réel</option>
                      <option data-id="element-1500">Conseils stratégiques</option>
                      <option data-id="element-1501">Assistance juridique</option>
                      <option data-id="element-1502">Information générale</option>
                    </select>
                  </div>
                  <div data-id="element-1503">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1504">
                      Message (optionnel)
                    </label>
                    <textarea id="message" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Précisez votre demande..." data-id="element-1505"></textarea>
                  </div>
                  <div className="pt-2" data-id="element-1506">
                    <Button variant="primary" fullWidth className="shadow-md" data-id="element-1507">
                      Demander un rappel
                    </Button>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-1508">
        <div className="container mx-auto px-4" data-id="element-1509">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1510">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1511">
              Prêt à maximiser vos chances de succès?
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-1512">
              Rejoignez les entreprises qui réussissent grâce à notre assistance
              Premium et augmentez significativement vos chances de remporter
              des marchés.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1513">
              <Link to="/premium-offers" data-id="element-1514">
                <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20 bg-yellow-500 hover:bg-yellow-400 text-blue-900" data-id="element-1515">
                  Découvrir nos offres
                </Button>
              </Link>
              <Link to="/parler-conseiller" data-id="element-1516">
                <Button variant="secondary" size="lg" className="bg-white text-blue-900 hover:bg-blue-50" data-id="element-1517">
                  Parler à un conseiller
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-20" data-id="element-1518">
        <div className="container mx-auto px-4" data-id="element-1519">
          <div className="text-center mb-16" data-id="element-1520">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-1521">
              Questions fréquentes
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-1522">
              Tout ce que vous devez savoir
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1523">
              Nous avons rassemblé les questions les plus fréquentes concernant
              notre service d'assistance Premium.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-1524">
            <div className="space-y-6" data-id="element-1525">
              {[{
              question: 'Comment fonctionne le service de revue de dossier?',
              answer: "Vous nous soumettez votre dossier de candidature via notre plateforme sécurisée. Nos experts l'examinent en détail selon une checklist complète et vous fournissent un rapport avec des recommandations d'amélioration dans un délai de 48h maximum (24h pour les demandes urgentes)."
            }, {
              question: "Quels sont les délais de réponse pour l'assistance en temps réel?",
              answer: "Nos experts s'engagent à répondre à vos questions dans un délai maximum de 15 minutes pendant nos heures d'ouverture (8h-20h, 6j/7). Pour les demandes complexes nécessitant des recherches approfondies, nous vous indiquons un délai estimé de réponse."
            }, {
              question: 'Comment se déroule une session de conseil stratégique?',
              answer: 'La session commence par un entretien préliminaire pour comprendre vos besoins et objectifs. Nos experts analysent ensuite votre positionnement et préparent des recommandations personnalisées. Une réunion de présentation est organisée pour discuter des stratégies proposées et répondre à vos questions.'
            }, {
              question: "Vos experts sont-ils spécialisés par secteur d'activité?",
              answer: "Oui, notre équipe est composée d'experts spécialisés dans différents secteurs (BTP, IT, Santé, Énergie, etc.) et domaines d'expertise (juridique, financier, technique). Nous vous mettons en relation avec les experts les plus pertinents selon votre secteur et vos besoins spécifiques."
            }, {
              question: 'Comment garantissez-vous la confidentialité de nos informations?',
              answer: 'Nous prenons très au sérieux la confidentialité de vos données. Tous nos experts signent des accords de confidentialité stricts, et notre plateforme utilise un chiffrement de bout en bout. Nous pouvons également signer des NDA spécifiques à votre entreprise si nécessaire.'
            }].map((faq, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1526">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1527">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600" data-id="element-1528">{faq.answer}</p>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-1529">
              <p className="text-gray-600 mb-4" data-id="element-1530">
                Vous avez d'autres questions?
              </p>
              <Link to="/parler-conseiller" data-id="element-1531">
                <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-1532">
                  Contactez-nous
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-1533" />
      <FloatingCTA data-id="element-1534" />
    </div>;
}